
import {
  getStaffInfo,
  getRegionList,
  getBaseConfigList,
  getStationList,
  saveStaffShopowner,
  saveStaffClerk,
  saveStaffInfo,
  getDepartmentOptionList,
  getStaffAllInfo,
  getNationList,
  getDepartmentOptionNewList,
  getPartnerStoreList
} from '@/api/humanResources.js'

import { getToken, setToken } from '@/utils/auth'
import { Notify } from 'vant'

const state = {
  token: getToken()
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    setToken(token)
  }
}

const actions = {
  setToken({ state, commit }, token) {
    commit('SET_TOKEN', token)
  },
  async wxLogin({ state, commit, dispatch }, data) {
    try {
      const { staff_access_info } = await dispatch('weixin/deliveryWxLogin', data, { root: true })
      const token = staff_access_info.token
      await dispatch('setToken', token)
      return token
    } catch (error) {
      error.message && Notify({ type: 'danger', message: error.message })
      dispatch('setToken', '')
      throw error
    }
  },

  // 01-获取员工基础信息
  getStaffInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getStaffInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 02-提供省市区域列表
  getRegionList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getRegionList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 03-提供基础筛选项列表
  getBaseConfigList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getBaseConfigList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 04-提供岗位列表
  getStationList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getStationList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 05-合伙人店长-保存信息
  saveStaffShopowner({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveStaffShopowner(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 06-合伙人店员-保存信息
  saveStaffClerk({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveStaffClerk(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 07-保存员工信息
  saveStaffInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveStaffInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 09-获取部门选项信息
  getDepartmentOptionList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getDepartmentOptionList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 12-获取员工所有信息 （备注查询详细接口）
  getStaffAllInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getStaffAllInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 09-获取民族列表
  getNationList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getNationList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 11-获取部门选项树结构
  getDepartmentOptionNewList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getDepartmentOptionNewList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 14-获取合伙人门店选项(新2021-7-14)
  getPartnerStoreList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getPartnerStoreList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
